<!--
  同種藥物用的多重藥盒取藥, 補藥
-->

<template>
  <div>
    <Action 
      v-if="stage === 'confirmAmount'"
      v-on:confirmAmountFinish="confirmAmountFinish"
      :defaultNum="forAction.defaultNum"
      :autoCaculateAmount="false"
      :compType="'Confirm'"
      :defaultPackCount="theDrugStorage.pack_count"
      :deviceId="forAction.deviceId"
      :checkNum="forAction.checkNum" >
      <h5>確認藥盒內數量</h5>
    </Action>
    <Action 
      v-if="stage === 'action'"
      v-on:setActionData="getThisAmount"
      v-on:setTotalSumInstanly="getTotalSumInstanly"
      :defaultNum="forAction.defaultNum"
      :autoCaculateAmount="false"
      :defaultPackCount="0"
      :deviceId="forAction.deviceId"
      :onlyPc="true"
      :inputReadOnly="fetchReadOnly"
      :checkNum="forAction.checkNum" >
      <h5>自此藥盒取藥數量 (pc)</h5>
    </Action>
    <ActionBreak 
      v-if="stage === 'break'"
      v-on:goOn="goOn" 
      :residual="amount - totalAmount" />
    <Loader v-if="stage === 'next'">
      <p class="text-center" v-if="saveTaskCount !== 0">
        儲存第 {{ saveProgress }} 藥單中 
      </p>
    </Loader>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import Action from '../flowComp/Action';
import ActionBreak from '../flowComp/ActionBreak';
import Loader from '../common/Loader';

export default {
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    schedules: Array,
    summarySelectedMed: Object,
    reviewer: Object,
  },
  components: {
    Action,
    ActionBreak,
    Loader,
  },
  computed: {
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly() {
      if (this.barcodeData !== undefined && Object.keys(this.barcodeData).length > 0) return true;
      return false;
    },
    currentDrug() {
      return this.$store.getters.currentDrug;
    },
  },
  data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0,
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      saveDatas: [],
      oriNextDrugStorageId: undefined,
      saveProgress: 0,
      saveTaskCount: 0,
    };
  },
  destroyed() {
    console.log('批次取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0,
    };
    this.getEmitTimes = 0;
    this.saveDatas = [];
  },
  created() {
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id,
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id,
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },
  methods: {
    async confirmAmountFinish() {
      console.log('drugstorage', this.theDrugStorage);
      await this.$store.dispatch('updateCurrentDrugInDevice', this.theDrugStorage.id);
      // notice: the stock of drugStorage might change here.
      this.theDrugStorage = this.$store.state.drugInDevice.allDrugInDevice[this.theDrugStorage.id];
      //
      this.forAction = {
        defaultNum: this.amount - this.totalAmount, // the resident number for child.
        checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id,
      };

      this.stage = 'next';
      // 如果確認之後為0 就跳過該藥盒
      if (this.currentDrugInDevice.stock === 0) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          this.theDrugStorageIndex += 1;
          this.residual = this.amount - this.totalAmount;
          this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
          this.forAction = {
            defaultNum: this.amount - this.totalAmount, // the resident number for child.
            checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
            deviceId: this.theDrugStorage.device.id,
          };
          // set next DrugStorage
          const nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
          this.stage = 'break';
        } else {
          if ((this.amount - this.totalAmount) > 0) {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: `尚有${this.amount - this.totalAmount}未拿，請自行至外部藥盒拿取。`,
              keepOnTop: true,
            });
          }
          //20190426 add
          console.log('store.state.drugInDevice.currentDrugInDevice:',this.$store.state.drugInDevice.currentDrugInDevice);
          console.log('store.state.drugInDevice.nextDrugInDevice:',this.$store.state.drugInDevice.nextDrugInDevice);
          if (this.$store.state.drugInDevice.nextDrugInDevice){  
            console.log('store.state.drugInDevice.currentDrugInDevice.id:',this.$store.state.drugInDevice.currentDrugInDevice.id);
            console.log('store.state.drugInDevice.nextDrugInDevice.id:',this.$store.state.drugInDevice.nextDrugInDevice.id);
            //console.log(this.$store.state.drugInDevice);
            this.resetNextDrugInDevice();
            //沒有下個藥要取
            if (this.$store.getters.nextDrug === null) {
              console.log('remove:case a');
              this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
              this.$store.commit('REMOVE_NEXT_DEVICE');
            }
            else //還有下個藥可取
            {
              if(this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id)
              {
                //去撈下個藥的id並設為next device
                const tmpNextDrugStorage = this.$store.getters.nextDrug;
                console.log(tmpNextDrugStorage);
                if(tmpNextDrugStorage)
                {
                  console.log('tmpNextDrugStorage.device.id:',tmpNextDrugStorage.drugStorage[0].id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.drugStorage[0].id);
                  this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.drugStorage[0].device.id);
                }
                else
                {
                  console.log('remove:case b');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');    
                }
              }
            }
          }
          else
          {
            console.log('remove:case c');
            this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
            this.$store.commit('REMOVE_NEXT_DEVICE');  
          }
          setTimeout(() => { this.$emit('setActionData'); }, 1000);
        }
      } else {
        // notice: the stock of drugStorage might change here.
        this.theDrugStorage = this.$store.state.drugInDevice.allDrugInDevice[this.theDrugStorage.id];
        //
        this.forAction = {
          defaultNum: this.amount - this.totalAmount, // the resident number for child.
          checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
          deviceId: this.theDrugStorage.device.id,
        };
        setTimeout(() => {
          this.stage = 'action';
          this.$store.commit('SET_CURRENT_STEP', 'action');
        }, 200);
        this.getTotalSumInstanly(this.amount - this.totalAmount);
      }
    },
    moveCurrentStorageToHead(drugStorageId) {
      const current = this.drugStorageInQueue[drugStorageId];
      console.log(drugStorageId, current);
      delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = Object.values(this.drugStorageInQueue);
      this.drugStorageList = _.orderBy(this.drugStorageList, (o) => { return moment(o.expired_date); });
      this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData(data) {
      const currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        const remainPc = currentDrugStorage.stock - (currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count);
        let remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        let medRecrodNumber = null;
        if (this.medRecordId) medRecrodNumber = this.medRecordId;
        if (this.barcodeData.medRecordId) medRecrodNumber = this.barcodeData.medRecordId;
        if (this.$store.state.schedule.currentSchedule) medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        let eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        const sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -(data.num),
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id,
        };
        console.log(currentDrugStorage.stock, data.num, sentData);

        this.stage = 'next';
        return sentData;
      }
    },
    goOn() {
      console.log(this.theDrugStorage);
      let defaultNumCalc = 0;
      let checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id,
      };
      console.log(this.forAction);
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      // reset drugStorage id if it has been changed previous.
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log('resetNextDrugInDevice');
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
          // save the drugStorage id temporaliy.
          this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:',this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly(val) {
      console.log('get total amount instanly', val);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          const nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
          console.log('set next device');
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        if (this.$store.getters.nextDrug === null) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        }
        else //還有下個藥可取
        {
          if(this.$store.state.drugInDevice.nextDrugInDevice)
          {
            if(this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id)
            {
              //去撈下個藥的id並設為next device
              const tmp2NextDrugStorage = this.$store.getters.nextDrug;
              console.log(tmp2NextDrugStorage);
              if(tmp2NextDrugStorage)
              {
                console.log('tmp2NextDrugStorage.device.id:',tmp2NextDrugStorage.drugStorage[0].id);
                this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.drugStorage[0].id);
                this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.drugStorage[0].device.id);
              }
              else
              {
                console.log('remove:case bb');
                this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                this.$store.commit('REMOVE_NEXT_DEVICE');    
              }
            }
          }
        }
      }
    },
    async getThisAmount(data) {
      this.$store.commit('SET_APP_CANCEL_STATUS', false);
      console.log(this.$store.state.currentApp.cancel);
      this.getEmitTimes += 1; // prevent over emitting
      if (this.getEmitTimes === 1) {
        // data: device, num
        this.totalAmount += data.num;
        // this.saveDatas.push(this.saveData(data));
        this.stage = 'next';
        await this.saveDataOneByOne(this.saveData(data));
        try {
          await this.deleteSchedules(this.summarySelectedMed[this.currentDrug.med.id]);
        } catch (err) {
          this.$store.commit('SET_MESSAGE', { type: 'warn', context: '刪除藥單錯誤' });
        }

        // increment the index
        this.theDrugStorageIndex += 1;
        // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);
        if (this.totalAmount < this.amount) {
          if (this.theDrugStorageIndex < this.drugStorageList.length) {
            this.residual = this.amount - this.totalAmount;
            this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
            console.log(this.theDrugStorage);
            this.stage = 'break';
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: `尚有${this.amount - this.totalAmount}未拿，請自行至外部藥盒拿取。`,
              keepOnTop: true,
            });
            this.getEmitTimes = 0;
            // remove the res of schedules, since the remain amount would be fetched outside.
            await this.removeTheRestSchedules(this.summarySelectedMed[this.currentDrug.med.id]);
            this.$emit('setActionData');
          }
        } else {
          this.$emit('setActionData');
          console.log('finished');
        }
      }
    },
    async saveDataOneByOne(item) {
      const currentSelectMed = this.summarySelectedMed[this.currentDrug.med.id];
      // reverse the fetch amount and save it to db.
      // array of actions. (due to crossing drugStorages.)
      let amountUsedInTheDrugStorage = Math.abs(item.number1); // amount has used in current DrugStorage
      let originalStockInTheDrugStorage = item.stock + amountUsedInTheDrugStorage; // 先推算回還沒拿取之前的數量
      // iterate tasks
      this.saveTaskCount = currentSelectMed.schedules.length;
      for (let j = 0; j < currentSelectMed.schedules.length; j += 1) {
        this.saveProgress = j + 1;
        const scheduleId = currentSelectMed.schedules[j];
        const schedule = _.find(this.schedules, (o) => { return o.id === scheduleId; });
        // schedule.fetched indicates that it is all saved into db.
        if (schedule.fetched === false) {
          if (amountUsedInTheDrugStorage - schedule.amount >= 0) { // 輪到這張藥單數量剛好取完或是還有剩餘
            amountUsedInTheDrugStorage -= schedule.amount;
            originalStockInTheDrugStorage -= schedule.amount;
            const copyItem = Object.assign({}, item);
            copyItem.number1 = -(schedule.amount);
            copyItem.med_record_no = schedule.patient.med_record_number;
            copyItem.stock = originalStockInTheDrugStorage;
            /* eslint-disable no-await-in-loop */
            console.log('enough amount. save.');
            try {
              await this.instance.put(`/api/drug-storage/${item.id}/`, copyItem);
            } catch (err) {
              this.$store.commit('SET_MESSAGE', { type: 'warn', context: `儲存取藥錯誤:${item.id}` });
            }
            schedule.fetched = true;
          } else {
            if (amountUsedInTheDrugStorage > 0) {
              const copyItem = Object.assign({}, item);
              copyItem.number1 = -(amountUsedInTheDrugStorage); // remain number in the drugStorage.
              schedule.amount -= amountUsedInTheDrugStorage; // 該藥單扣掉已經取走的部份
              copyItem.med_record_no = schedule.patient.med_record_number;
              /* eslint-disable no-await-in-loop */
              console.log('amount insuffcient, to next drugstorage.', amountUsedInTheDrugStorage, schedule.amount);
              try {
                await this.instance.put(`/api/drug-storage/${item.id}/`, copyItem);
              } catch (err) {
                this.$store.commit('SET_MESSAGE', { type: 'warn', context: `儲存取藥錯誤:${item.id}` });
              }
              break;
            }
          }
        }
      }
      this.saveTaskCount = 0;
      this.saveProgress = 0;
    },
    async deleteSchedules(currrentSummaryMed) {
      const schedules = currrentSummaryMed.schedules;
      const promises = [];
      const deletedScheduleId = [];
      schedules.forEach((id) => {
        const schedule = _.find(this.schedules, (o) => { return o.id === id; });
        if (schedule.fetched) {
          // only delete it if fetched.
          promises.push(this.instance.delete(`/api/fetch-schedule/${id}/`));
          deletedScheduleId.push(id);
        }
      });
      // remove the deleted schedule ids. this is used when fetchDrug across different devices.
      deletedScheduleId.forEach((id) => {
        const ind = schedules.findIndex((o) => { return o === id; });
        schedules.splice(ind, 1);
      });
      return axios.all(promises);
    },
    removeTheRestSchedules(currrentSummaryMed) {
      const schedules = currrentSummaryMed.schedules;
      const promises = [];
      schedules.forEach((id) => {
        promises.push(this.instance.delete(`/api/fetch-schedule/${id}/`));
      });
      return axios.all(promises);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ActionWrap.vue?cae3c3aa